import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { forgotPassword } from '../auth/authApi';
import Layout from '../components/Layout';
import Spinner from '../components/Spinner';

const inputStyle = {
  width: '100%', padding: '12px', borderRadius: '6px',
  border: '1px solid rgba(255, 255, 255, 0.3)', backgroundColor: 'rgba(255, 255, 255, 0.1)',
  color: '#fff', fontSize: '1em', outline: 'none',
};
const labelStyle = { display: 'block', marginBottom: '8px', color: '#fff', fontWeight: '500' };

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await forgotPassword(email);
    } finally {
      // Always show the same confirmation — never reveal whether the email exists.
      setSubmitted(true);
      setLoading(false);
    }
  };

  return (
    <Layout>
      <section id="wrapper">
        <div className="inner" style={{ paddingTop: '40px' }}>
          <h2 className="major" style={{ textAlign: 'center' }}>Reset your password</h2>

          <div className="content" style={{
            maxWidth: '600px', margin: '20px auto 40px', padding: '30px',
            backgroundColor: 'rgba(27, 31, 34, 0.85)', borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
          }}>
            {submitted ? (
              <div style={{ textAlign: 'center', color: '#fff' }}>
                <p style={{ fontSize: '1.05em', lineHeight: 1.6 }}>
                  If an account exists for <strong>{email}</strong>, we&rsquo;ve sent a link to reset
                  your password. Check your inbox (and spam folder).
                </p>
                <p style={{ marginTop: '20px' }}>
                  <Link to="/login" style={{ color: '#FF5722', textDecoration: 'none' }}>Back to login</Link>
                </p>
              </div>
            ) : (
              <>
                <p style={{ color: '#fff', opacity: 0.85, marginBottom: '20px', lineHeight: 1.6 }}>
                  Enter the email on your account and we&rsquo;ll send you a link to set a new password.
                </p>
                <form onSubmit={handleSubmit}>
                  <div style={{ marginBottom: '20px' }}>
                    <label htmlFor="email" style={labelStyle}>Email</label>
                    <input id="email" type="email" value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email" style={inputStyle} />
                  </div>
                  <button type="submit" disabled={loading} style={{
                    width: '100%', padding: '15px', borderRadius: '6px', border: 'none',
                    backgroundColor: loading ? '#999' : '#FF5722', color: '#fff',
                    fontSize: '1.1em', fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer',
                  }}>
                    {loading ? (<span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}><Spinner size={16} />Sending…</span>) : 'Send reset link'}
                  </button>
                </form>
                <p style={{ marginTop: '20px', textAlign: 'center', fontSize: '0.9em', opacity: 0.8, color: '#fff' }}>
                  Remembered it? <Link to="/login" style={{ color: '#FF5722', textDecoration: 'none' }}>Back to login</Link>
                </p>
              </>
            )}
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default ForgotPassword;
